import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { FaElementor, FaUsersCog, FaUserShield, FaAccessibleIcon } from 'react-icons/fa';

import { IAppState } from 'src/store';
import { modalActions } from 'src/redux/modalRedux';
import { MODAL_TYPES } from 'src/appConfig/modal';
import { commonActions } from 'src/redux/commonRedux';
import {
  Button,
  Checkbox,
  DatePicker,
  DateRangePicker,
  ImageLazy,
  Input,
  TimePicker,
  WeekPicker,
  View,
  Tag,
  InputPassword,
} from 'src/components/common';
import Loading from 'src/components/Loading';
import ComfirmationCodeField from 'src/components/ComfirmationCodeField';
import RadioButton from 'src/components/common/RadioButton';
import { generateArray } from 'src/utils';
import NewUser from 'src/containers/ManageUsers/NewUser';
import { YesNoModalData } from 'src/components/Modal/YesNoModal';
import NewDeposition from '../ManageDepositions/NewDeposition';
import UserDetail from '../ManageUsers/UserDetail';
import { Deposition } from 'src/dataFactory/depositionFactory';
const Dev: React.FC<Props> = ({ isLoading, setLoading, showModal, closeModal }) => {
  const [count, setCount] = useState(0);
  const [datePicked, setDatePicked] = useState<Date>(new Date());
  const [dateRange, setDateRange] = useState<[Date, Date]>([new Date(), new Date()]);
  const [newTime, setNewTime] = useState<Date>(new Date());
  const [week, setWeek] = useState<[Date, Date]>([new Date(), new Date()]);
  const [isCreateDepoModalVisible, setIsCreateDepoModalVisible] = useState(false);
  const [isUpdateDepoModalVisible, setIsUpdateDepoModalVisible] = useState(false);
  const [isNewUserModalVisible, setIsNewUserModalVisible] = useState(false);
  const [isUpdateUserModalVisible, setIsUpdateUserModalVisible] = useState(false);
  const user = {
    firstName: 'John Fake',
    lastName: 'Doe',
    email: 'john.doe@gmail.com',
    phoneNumber: '+1-202-555-0141',
    role: 'ADMIN',
    id: '1',
    companyOrLawFirm: 'ABC',
  };
  const handleOpenYesNoModal = () => {
    showModal({
      type: MODAL_TYPES.YES_NO_MODAL,
      data: {
        title: 'Welcome',
        message: 'You are welcome',
        onOk: closeModal,
        onCancel: closeModal,
      } as YesNoModalData,
    });
  };
  const handleOpenOkModal = () => {
    showModal({
      type: MODAL_TYPES.OK_MODAL,
      data: {
        title: 'Welcome',
        message: 'You are welcome',
        onOk: closeModal,
      },
    });
  };

  const handleCodeFieldChange = (value: string) => {
    console.log('value', value);
  };
  const detail: Deposition = {
    requester: {
      name: 'Nga Le',
      id: '1',
      email: 'ngale@gmail.com',
      imageURL: 'url',
      role: 'CLIENT',
      position: 'Court Reporter',
    },
    uri: '1',
    caseId: '123123',
    name: 'Viet Anh',
    caseName: 'Viet Anh',
    depositionDate: '2021-05-13T21:00:25.088Z',
    openDate: '2021-05-13T21:00:25.088Z',
    actualDepositionDate: '2021-05-13T21:00:25.088Z',
    actualDepositionTime: '2021-05-13T21:00:25.088Z',
    circuitId: 1,
    id: '1',
    status: 'active',
    files: {
      exhibit: [],
      final: [],
    },
    subResources: {
      exhibitUploaders: {
        uri: '',
        uploadUri: '',
        total: 1,
      },
      finalDepositionFiles: {
        uri: '',
        uploadUri: '',
        total: 1,
      },
      productionFiles: {
        uri: '',
        uploadUri: '',
        total: 1,
      },
      involvedPartiesUri: '',
      requesterUserUri: '',
    },
    caption: 'ZZZ',
    involvedParties: [
      {
        id: '1',
        name: 'Esther Howard',
        role: 'CLIENT',
        position: 'Court Reporter',
        imageURL: 'https://picsum.photos/200/300',
        email: 'esther_haw@datahouse.com',
      },
    ],
  };
  const handleCheckboxChange = (value: any[]) => {
    console.log('handleCheckboxChange', value);
  };

  const handleDatePickerChage = (value: Date) => {
    setDatePicked(value);
  };

  const handleDateRangePickerChage = (value: [Date, Date]) => {
    console.log(`handleDateRangePickerChage`, value);
    setDateRange(value);
  };

  const handleTimePickerChage = (value: Date) => {
    console.log('handleTimePickerChage', value);
    setNewTime(value);
  };

  const handleWeekPickerChage = (value: any) => {
    console.log(value);
    setWeek(value);
  };
  const handleCloseModal = () => {
    setIsCreateDepoModalVisible(false);
    setIsNewUserModalVisible(false);
    setIsUpdateUserModalVisible(false);
    setIsUpdateDepoModalVisible(false);
  };
  const openNewDepositionModal = () => {
    setIsCreateDepoModalVisible(true);
  };
  const openUpdateDepositionModal = () => {
    setIsUpdateDepoModalVisible(true);
    console.log('Detaill neff', detail);
  };
  const openUpdateUserModal = () => {
    setIsUpdateUserModalVisible(true);
  };
  const openNewUserModal = () => {
    setIsNewUserModalVisible(true);
  };
  return (
    <View>
      <View className="mt-40">
        <UserDetail
          user={{
            id: '1',
            firstName: 'John',
            lastName: ' Doe',
            email: 'john.doe@gmail.com',
            role: 'Client',
            companyOrLawFirm: 'ABC',
          }}
        />
      </View>
      <View className="mt-40" isRow justify="space-around">
        <Button onClick={openNewDepositionModal}>OPEN NEW DEPOSITION MODAL</Button>
        <View>{isCreateDepoModalVisible && <NewDeposition onClose={handleCloseModal} />}</View>

        <Button onClick={openUpdateDepositionModal}>OPEN UPDATE DEPOSITION MODAL</Button>
        <View>{isUpdateDepoModalVisible && <NewDeposition deposition={detail} onClose={handleCloseModal} />}</View>

        <Button onClick={openNewUserModal}>OPEN NEW USER MODAL</Button>
        <View>{isNewUserModalVisible && <NewUser onClose={handleCloseModal} />}</View>

        <Button onClick={openUpdateUserModal}>OPEN EDIT USER MODAL</Button>
        <View>{isUpdateUserModalVisible && <NewUser user={user} onClose={handleCloseModal} />}</View>

        <Tag>Primary</Tag>
        <Tag variant="is-success">Success</Tag>
        <Tag variant="is-danger">Danger</Tag>
        <Tag variant="is-dark">Dark</Tag>
        <Tag variant="is-info">Info</Tag>
        <Tag variant="is-light">Light</Tag>
        <Tag variant="is-black">Black</Tag>
        <Tag variant="is-warning">Warning</Tag>
      </View>
      <View className="mt-40" isRow justify="space-around">
        <Tag isLight>Primary</Tag>
        <Tag isLight variant="is-success">
          Success
        </Tag>
        <Tag isLight variant="is-danger">
          Danger
        </Tag>
        <Tag isLight variant="is-dark">
          Dark
        </Tag>
        <Tag isLight variant="is-info">
          Info
        </Tag>
        <Tag isLight variant="is-light">
          Light
        </Tag>
        <Tag isLight variant="is-black">
          Black
        </Tag>
        <Tag isLight variant="is-warning">
          Warning
        </Tag>
      </View>

      <View className="mt-40">
        <div className="columns">
          <div className="column">
            <DateRangePicker selecteds={dateRange} label="date range 1" onChange={handleDateRangePickerChage} />
          </div>
          <div className="column">
            <DateRangePicker label="date range 1" onChange={handleDateRangePickerChage} errorMessage="error go here" />
          </div>
          <div className="column">
            <DateRangePicker
              selecteds={dateRange}
              label="date range 1"
              onChange={handleDateRangePickerChage}
              disabled
            />
          </div>
        </div>
      </View>

      <View className="mt-40">
        <div className="columns">
          <div className="column">
            <WeekPicker weekSelected={week} label="week picker 1" onChange={handleWeekPickerChage} />
          </div>
          <div className="column">
            <WeekPicker
              weekSelected={week}
              label="week picker 1"
              onChange={handleWeekPickerChage}
              errorMessage="error go here"
            />
          </div>
          <div className="column">
            <WeekPicker weekSelected={week} label="week picker 1" onChange={handleWeekPickerChage} disabled />
          </div>
        </div>
      </View>

      <View className="mt-40">
        <div className="columns">
          <div className="column">
            <DatePicker selected={datePicked} label="date 1" onChange={handleDatePickerChage} />
          </div>
          <div className="column">
            <DatePicker label="date 2" onChange={handleDatePickerChage} errorMessage="error go here" />
          </div>
          <div className="column">
            <DatePicker selected={datePicked} label="date 3" onChange={handleDatePickerChage} disabled />
          </div>
        </div>
      </View>

      <View className="mt-40">
        <div className="columns">
          <div className="column">
            <TimePicker selected={newTime} label="time 1" onChange={handleTimePickerChage} />
          </div>
          <div className="column">
            <DatePicker label="date 2" onChange={handleDatePickerChage} errorMessage="error go here" />
          </div>
          <div className="column">
            <DatePicker selected={datePicked} label="date 3" onChange={handleDatePickerChage} disabled />
          </div>
        </div>
      </View>

      <View className="mt-40" isRow justify="space-around">
        <h1>{count}</h1>
      </View>

      <View className="mt-40" isRow justify="space-around">
        <Button onClick={() => setCount(count + 1)}>Hello</Button>
        <Button isOutline onClick={handleOpenYesNoModal}>
          Modal
        </Button>
        <Button isOutline disabled>
          Disabled
        </Button>
        <Button disabled>Pri Disabled</Button>
      </View>

      <View className="mt-40" isRow justify="space-around">
        <Button icon={<FaElementor />}>To Interview</Button>
        <Button icon={<FaUserShield />} iconPosition="right">
          Icon Right
        </Button>
        <Button icon={<FaUsersCog />} variant="outline">
          Icon Left
        </Button>
        <Button icon={<FaAccessibleIcon />} iconPosition="right" variant="outline">
          Icon Right
        </Button>
      </View>

      <View className="mt-40" isRow justify="space-around">
        <Button onClick={handleOpenOkModal} variant="outline">
          OK Modal
        </Button>
        <Button onClick={handleOpenYesNoModal}>Yes No Modal</Button>
      </View>

      <View className="mt-40" isRow justify="space-around">
        <Button variant="text">Text Button</Button>
        <Button variant="link">Link Button</Button>
        <Button variant="outline">Outline Button</Button>
      </View>

      <View className="mt-40" isRow justify="space-around">
        <Loading loadingStyle={1} />
        <Loading loadingStyle={2} />
        <Loading loadingStyle={3} />
        <Loading loadingStyle={4} />
        <Loading loadingStyle={5} />
      </View>
      <View className="mt-40">
        <ComfirmationCodeField onChange={handleCodeFieldChange} />
      </View>

      <View className="mt-40">
        <Checkbox.Group
          label="Hello World Checkbox"
          options={[
            { label: 'Hello', value: 'Hello' },
            { label: 'World', value: 'World' },
            { label: 'Loc', value: 'World' },
            { label: 'Tran', value: 'World' },
          ]}
          onChange={handleCheckboxChange}
          columns={3}
        />
      </View>
      <View className="mt-40">
        <RadioButton
          label="Hello World Radio"
          options={[
            { label: 'Hello', value: 'Hello' },
            { label: 'World', value: 'World' },
            { label: 'Loc', value: 'World' },
            { label: 'Tran', value: 'World' },
          ]}
        />
      </View>
      <View className="mt-40">
        <Input label="Text" defaultValue="1" />
        <Input label="Text Error" defaultValue="2" errorMessage="aaaaa" />
        <Input label="Text Disabled" defaultValue="3" disabled />
        <InputPassword label="Password" />
      </View>
      <View className="mt-40">
        {_.chunk(generateArray(7, '0'), 4).map((smallArray: any[], idx: number) => (
          <div className="columns">
            {smallArray.map((_, i: number) => (
              <div className="column">
                <ImageLazy style={{ height: '200px' }} src={`https://picsum.photos/1000/1000?random=${idx * 5 + i}`} />
              </div>
            ))}
          </div>
        ))}
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {
  setLoading: commonActions.setLoading,
  showModal: modalActions.showModal,
  closeModal: modalActions.closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dev);
